import React, { Component } from "react";
import { Button, ButtonGroup } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LaborCrews from "./LaborCrews";
import ProjLaborList from "./ProjLaborList";

class LaborMain extends Component {
  state = {
    viewType: "list",
  };

  handleClick_viewType = (e) => {
    e.preventDefault();
    this.setState({ viewType: e.target.name });
  };

  renderViewTypeSelector = () => {
    const { viewType } = this.state;
    return (
      <div className="card mx-2 mt-2 mb-0">
        <div className="card-body bg-lightgray p-2">
          <div className="form-row form-group form-inline mb-0">
            <ButtonGroup className="ml-1">
              <Button
                name="list"
                id="list"
                color="secondary"
                outline
                onClick={this.handleClick_viewType}
                active={viewType === "list"}
              >
                <FontAwesomeIcon icon="list" className="fa-fw mr-2" />
                List
              </Button>
              <Button
                name="crew"
                id="crew"
                color="secondary"
                outline
                onClick={this.handleClick_viewType}
                active={viewType === "crew"}
              >
                <FontAwesomeIcon icon="users" className="fa-fw mr-2" />
                Crew Setup
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
    );
  };

  renderBody = () => {
    const { viewType } = this.state;
    switch (viewType) {
      case "list":
        return <ProjLaborList {...this.props} />;
      case "crew":
        return <LaborCrews {...this.props} />;
      default:
        break;
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.renderViewTypeSelector()}
        {this.renderBody()}
      </React.Fragment>
    );
  }
}

export default LaborMain;
